export default __webpack_public_path__ + "static/media/wait.e0bee96b.gif";